'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'cloud-arrow-up';
var width = 576;
var height = 512;
var aliases = [62338,"cloud-upload","cloud-upload-alt"];
var unicode = 'f0ee';
var svgPathData = 'M240 32c-79.5 0-144 64.5-144 144 0 8 .7 15.9 1.9 23.5-56.9 19.2-97.9 73-97.9 136.5 0 79.5 64.5 144 144 144l304 0c70.7 0 128-57.3 128-128 0-51.6-30.5-96.1-74.5-116.3 6.7-13.1 10.5-28 10.5-43.7 0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1zM112 176c0-70.7 57.3-128 128-128 52.2 0 97.1 31.2 117 76 1 2.2 2.9 3.9 5.2 4.5s4.8 .2 6.8-1.3c13.2-9.6 29.4-15.2 47-15.2 44.2 0 80 35.8 80 80 0 15.9-4.7 30.8-12.7 43.2-1.3 2-1.6 4.6-.9 6.8s2.5 4.1 4.8 5C529.8 263 560 304 560 352 560 413.9 509.9 464 448 464l-304 0c-70.7 0-128-57.3-128-128 0-58.6 39.5-108.1 93.3-123.2 4.1-1.1 6.6-5.3 5.7-9.4-1.9-8.8-2.9-18-2.9-27.4zm181.7 18.3c-3.1-3.1-8.2-3.1-11.3 0l-72 72c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L280 219.3 280 376c0 4.4 3.6 8 8 8s8-3.6 8-8l0-156.7 58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-72-72z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;